<template lang="pug">
    button.plane-button(@click="$emit('click', $event)")
        slot
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    name: 'PlaneButton'
});
</script>

<style lang="scss">
.plane-button {
    font-size: 1.14em;
    line-height: #{29 / 24};
    font-weight: 700;
    padding: 0.8em 1em 0.75em;
    background: var(--color-new-accent-bg, #ceff40);
    color: var(--color-text-over-new-accent, #333333);

    @media (--viewport-mobile-m) {
        font-size: 1em;
        padding: 0.5em 1em 0.45em;
    }

    @media (hover: hover) {
        &:hover {
            background: var(--color-main-hover, #666666);
            color: var(--color-accent-text, #fff);
        }
    }
}
</style>
